import gql from 'graphql-tag';

/** Read-only preview endpoint; this query cannot request deletion. */
export default gql`
    query EntityDeletionPreview($_id: ID!, $tpID: ID!) {
        getEntityDeletionPreview(_id: $_id, tpID: $tpID) {
            _id classType deletedTs action blocker blockingReason
        }
    }
`;
